import type { Tour } from 'nextstepjs';
import { Store, CreditCard } from 'lucide-react';

/**
 * Store Creation Tour
 * Guides users through creating their first store
 */
export const storeCreationTour: Tour = {
  tour: 'store-creation',
  steps: [
    {
      icon: <Store className="h-5 w-5" />,
      title: "Welcome! Let's create your store",
      content: (
        <div className="space-y-2">
          <p>Your store is where you'll manage products, orders, and plugins.</p>
          <p className="text-muted-foreground text-sm">This will only take a minute!</p>
        </div>
      ),
      selector: '#store-name-input',
      side: 'right',
      showControls: true,
      showSkip: true,
      pointerPadding: 10,
      pointerRadius: 8,
    },
    {
      icon: <CreditCard className="h-5 w-5" />,
      title: 'Display currencies',
      content: (
        <div className="space-y-2">
          <p>Choose the currencies customers can view prices in.</p>
          <p className="text-muted-foreground text-sm">
            You can select multiple currencies for international customers.
          </p>
        </div>
      ),
      selector: '#store-display-currency-select',
      side: 'right',
      showControls: true,
      showSkip: true,
      pointerPadding: 10,
      pointerRadius: 8,
    },
    {
      icon: <CreditCard className="h-5 w-5" />,
      title: 'Charge currency',
      content: (
        <div className="space-y-2">
          <p>Choose the currency you'll use to charge customers' payment methods.</p>
          <p className="text-muted-foreground text-sm">
            This is the currency your payment processor will use.
          </p>
        </div>
      ),
      selector: '#store-charge-currency-select',
      side: 'right',
      showControls: true,
      showSkip: true,
      pointerPadding: 10,
      pointerRadius: 8,
    },
    {
      icon: <CreditCard className="h-5 w-5" />,
      title: 'Reporting currency',
      content: (
        <div className="space-y-2">
          <p>Choose the currency for financial reporting and analytics.</p>
          <p className="text-muted-foreground text-sm">This defaults to your charge currency.</p>
        </div>
      ),
      selector: '#store-currency-select',
      side: 'right',
      showControls: true,
      showSkip: true,
      pointerPadding: 10,
      pointerRadius: 8,
    },
    {
      icon: <>🚀</>,
      title: 'Create your store!',
      content: (
        <div className="space-y-2">
          <p>All set! Click here to create your store.</p>
        </div>
      ),
      selector: '#create-store-submit-button',
      side: 'left',
      showControls: false,
      showSkip: true,
      pointerPadding: 10,
      pointerRadius: 8,
    },
  ],
};
